import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  QueryList,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import {NgFor, NgStyle} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {ToolbarModule} from '@q9elements/ui-kit/components';
import {GraphHelperService} from '../../../diagram-render/helpers/graph-helper.service';
import {StickerCommands} from '../../../commands/sticky-note/sticker.commands';
import {DragHandlerService} from '../shared/drag-handler.service';
import {MatButtonModule} from '@angular/material/button';
import {leftToolbarPaletteSticker} from 'src/app/shared/constants/color-picker.constants';
import {PositionType} from 'src/app/diagram-render/styles/diagram-type-styles.model';
import {DiagramTypeConfigService} from '../../../core/services/diagram-type-config.service';
import {ModeDataService} from '../../../editor-state/mode-data.service';

@Component({
  selector: 'app-sticker-note-toolbar',
  templateUrl: './sticker-note-toolbar.component.html',
  styleUrls: ['./sticker-note-toolbar.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgFor, NgStyle, ToolbarModule, TranslateModule, MatButtonModule]
})
export class StickerNoteToolbarComponent implements AfterViewInit {
  public readonly palette = leftToolbarPaletteSticker;

  @ViewChildren('stickerDragElement', {read: ElementRef})
  private stickerDragElements: QueryList<ElementRef>;

  constructor(
    private readonly graphService: GraphHelperService,
    private readonly stickerCommands: StickerCommands,
    private readonly dragHandlerSvc: DragHandlerService,
    private readonly diagramTypeConfigSvc: DiagramTypeConfigService,
    private readonly modeDataSvc: ModeDataService
  ) {}

  ngAfterViewInit() {
    this.setupStickerDragHandlers();
  }

  private setupStickerDragHandlers() {
    const {w: width, h: heigh} = this.diagramTypeConfigSvc.stickerNoteSettings.defaultShape;

    this.stickerDragElements.forEach((elementRef, i) => {
      const color = this.palette[i];
      const previewElement = this.dragHandlerSvc.createPreviewElement(width, heigh);

      this.dragHandlerSvc.createDragHandler(
        (x, y) => this.createStickerCommand(x, y, color),
        elementRef.nativeElement,
        previewElement,
        true
      );
    });
  }

  private createStickerCommand(x: number, y: number, color: string) {
    return this.stickerCommands.create(
      this.diagramTypeConfigSvc.stickerNoteSettings.preparePayload({
        x,
        y,
        mxKey: this.modeDataSvc.isEditMode() ? this.graphService.getFreeNumber(7) : -Date.now(),
        position: PositionType.DEFAULT,
        color
      })
    );
  }
}
